import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { ChevronRight, Mail, MapPin, Phone } from "lucide-react";
function FooterQuickLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <p className="text-sm text-muted-foreground font-mono">No links configured.</p>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="group flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
            <ChevronRight className="size-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-primary" />
            <span>{item.label}</span>
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const techDocs = [{
    title: "Credit Solutions",
    path: "/CreditSolutionsPage"
  }, {
    title: "Business Consulting",
    path: "#"
  }, {
    title: "Funding Programs",
    path: "#"
  }];
  return <section data-section-id="253155" id="footer" className="bg-background text-foreground border-t border-border pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed font-default">
              Lake Stone Enterprise, LLC provides elite personal and business credit management. We help you scale your financial potential and secure the funding you deserve.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground uppercase tracking-wider text-sm mb-6 flex items-center gap-2">
              <span className="w-2 h-2 bg-primary rounded-md inline-block"></span>
              Navigation
            </h3>
            <MenuProvider menu_id="44">
              <FooterQuickLinks />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground uppercase tracking-wider text-sm mb-6 flex items-center gap-2">
              <span className="w-2 h-2 bg-primary rounded-md inline-block"></span>
              Our Expertise
            </h3>
            <ul className="space-y-3">
              {techDocs.map((doc, i) => <li key={i} data-index={i}>
                  <Link to={doc.path} className="group flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
                    <ChevronRight className="size-3 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-primary" />
                    <span>{doc.title}</span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground uppercase tracking-wider text-sm mb-6 flex items-center gap-2">
              <span className="w-2 h-2 bg-primary rounded-md inline-block"></span>
              Contact
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground group">
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary group-hover:scale-110 transition-transform" />
                <span>Lake Stone Enterprise, LLC</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground group">
                <Phone className="size-4 shrink-0 text-primary group-hover:scale-110 transition-transform" />
                <span className="group-hover:text-primary transition-colors">1-888-322-2844</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground group">
                <Mail className="size-4 shrink-0 text-primary group-hover:scale-110 transition-transform" />
                <span className="group-hover:text-primary transition-colors">ls@lakestoneenterprise.net</span>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-xs text-muted-foreground font-mono">
            &copy; {currentYear} LAKE STONE ENTERPRISE, LLC. All rights reserved.
          </p>
          
          <div className="flex items-center gap-3 px-4 py-2 border border-border bg-muted/10 rounded-md backdrop-blur-sm">
            <span className="relative flex size-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-lg size-2.5 bg-primary"></span>
            </span>
            <span className="text-xs font-mono text-muted-foreground uppercase tracking-widest">
              Financial Network: Active
            </span>
          </div>
        </div>
      </div>
    </section>;
}